import { render, staticRenderFns } from "./ProcedimentoOutrasDatas.vue?vue&type=template&id=3ee0b580&"
import script from "./ProcedimentoOutrasDatas.vue?vue&type=script&lang=js&"
export * from "./ProcedimentoOutrasDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports